import { ROBOT_MEDIA_BASE_URL } from '/@/constants'

/**
 * 使用机器人媒体基础 URL 拼接相对路径（用于 objectKey 等）
 */
export function joinMediaUrl(path?: string): string {
  if (!path) return ''
  if (/^https?:\/\//i.test(path)) return path
  const base = ROBOT_MEDIA_BASE_URL.replace(/\/+$/, '')
  const p = String(path).replace(/^\/+/, '')
  return `${base}/${p}`
}

/**
 * 从告警项中解析出告警图片 URL（支持 objectKey 或 alarmImage）
 */
export function getAlarmImageUrl(item: { objectKey?: string; alarmImage?: string } | null | undefined): string {
  if (!item) return ''
  return joinMediaUrl(item.objectKey) || item.alarmImage || ''
}
